import React, { useEffect, useState } from "react";
import "./Casestudy.css";
import Sidebar from "../Components/Sidebar";
import { useNavigate } from "react-router-dom";

const Casestudy = () => {
  const [casestudies, setCasestudies] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const lang = localStorage.getItem("lang") || "en";
  /* const isPremium = localStorage.getItem("isPremium") === "true"; */

  const getText = (en, bn) => (lang === "bn" ? bn : en);

  useEffect(() => {
    const fetchCasestudies = async () => {
      const jwtToken = localStorage.getItem("jwtToken");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/casestudies`,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );

        const result = await response.json();

        if (!result.error) {
          setCasestudies(result.data);
        } else {
          console.error("Error fetching case studies:", result.msg);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchCasestudies();
  }, []);

  const renderStars = (score) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span key={i} className={i <= score * 5 ? "star filled" : "star"}>
          ★
        </span>
      );
    }
    return stars;
  };

  const handleCardClick = (study) => {
    if (study.show) {
      navigate(`/case/${study.case_id}`);
    } else {
      setShowModal(true);
    }
  };

  return (
    <div className="overview">
      <Sidebar />
      <div className="casestudy-container">
        <div
          className={lang === "bn" ? "bangla-font" : ""}
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          {getText("Case Studies", "কেস স্টাডি")}
        </div>
        <div
          className={lang === "bn" ? "bangla-font" : ""}
          style={{
            fontSize: "18px",
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          {getText(
            "Master Real-World Scenarios",
            "বাস্তব পরিস্থিতি আয়ত্ত করুন"
          )}
        </div>
        <div
          className={lang === "bn" ? "bangla-font" : ""}
          style={{
            fontSize: "18px",
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          {getText(
            "Practice with interactive case studies to enhance your decision-making skills",
            "ইন্টারেক্টিভ কেস স্টাডি চর্চা করে আপনার সিদ্ধান্ত গ্রহণের দক্ষতা বৃদ্ধি করুন"
          )}
        </div>

        <div className="casestudy-list">
          {casestudies.map((study) => (
            <div
              key={study.case_id}
              className={`casestudy-card ${!study.show ? "locked" : ""}`}
              onClick={() => handleCardClick(study)}
            >
              <div>{study.title}</div>
              <div className="stars">{renderStars(study.score)}</div>
              {!study.show && <div className="lock-overlay">🔒</div>}
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div
          className="premium-modal-overlay"
          onClick={() => setShowModal(false)}
        >
          <div
            className="premium-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="premium-modal-title">
              {getText("Upgrade to Premium", "প্রিমিয়ামে আপগ্রেড করুন")}
            </h2>
            <p className="premium-modal-text">
              {getText(
                "Unlock all case studies by subscribing to the premium plan.",
                "প্রিমিয়াম প্ল্যানে সাবস্ক্রাইব করে সব কেস স্টাডি আনলক করুন।"
              )}
            </p>
            <button
              className="premium-modal-button"
              onClick={() => navigate("/pricing")}
            >
              {getText("Go to Subscription Page", "সাবস্ক্রিপশন পেইজে যান")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Casestudy;
